import cx from 'classnames'
import React from 'react'

import Text, { TextStyles } from '@cinch/oxd-components/text/src'

import * as styles from './toggle.module.css'

interface ToggleProps {
  isSelected?: boolean
  onClick: () => any
  selectedLabel?: string
  unselectedLabel?: string
  size?: 'mini' | 'regular'
}

const Toggle: React.FC<ToggleProps> = ({
  isSelected = false,
  onClick,
  selectedLabel = '',
  unselectedLabel = '',
  size = 'regular',
}) => (
  <button
    type="button"
    onClick={onClick}
    className={cx(styles.toggle, {
      [styles.toggleSelected]: isSelected,
      [styles.toggleMini]: size === 'mini',
    })}
    aria-pressed={isSelected}
  >
    <span className={cx(styles.toggleContent, { [styles.toggleContentMini]: size === 'mini' })}>
      <Text
        type={TextStyles.bullet}
        className={cx(styles.toggleOption, styles.onToggle, { [styles.toggleOptionMini]: size === 'mini' })}
      >
        {selectedLabel}
      </Text>
      <Text
        type={TextStyles.bullet}
        className={cx(styles.toggleOption, styles.offToggle, { [styles.toggleOptionMini]: size === 'mini' })}
      >
        {unselectedLabel}
      </Text>
      <div className={cx(styles.toggleCircle, { [styles.toggleCircleMini]: size === 'mini' })} />
    </span>
  </button>
)

export default Toggle
